import { render, staticRenderFns } from "./api_config.vue?vue&type=template&id=96b1ce1e&scoped=true"
import script from "./api_config.vue?vue&type=script&lang=js"
export * from "./api_config.vue?vue&type=script&lang=js"
import style0 from "./api_config.vue?vue&type=style&index=0&id=96b1ce1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b1ce1e",
  null
  
)

export default component.exports